__turbopack_context__.v({
  "container": "nQUQhW_container",
  "coverageItem": "nQUQhW_coverageItem",
  "coverageList": "nQUQhW_coverageList",
  "links": "nQUQhW_links",
  "logo": "nQUQhW_logo",
  "readMore": "nQUQhW_readMore",
});
